import { SERIA_PLUS_V3_IMAGE_BASE_URL, createDescription, createSlideMarkers, createTab } from './utils';

export const architectureTab = createTab({
  slides: [
    {
      ...createDescription([
        'На первых этажах мы создаём пространства, которые гармонично дополняют жизнь за пределами',
        'квартиры. Торговые аллеи с колоннами, большие витрины магазинов и кафе словно приглашают жителей',
        'отдохнуть или сходить за покупками возле дома.',
      ]),
      imageAlt: 'Торговая аллея на первом этаже дома Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/thoughtful-architecture/1.webp`,
      markers: createSlideMarkers([
        {
          left: 998,
          tooltip: { placement: 'right', text: 'Разнообразие фасадных решений' },
          top: 330,
        },
        {
          left: 579,
          tooltip: { placement: 'right', text: 'Архитектурная подсветка' },
          top: 341,
        },
        {
          left: 934,
          tooltip: { placement: 'right', text: 'Витражное остекление первых этажей' },
          top: 656,
        },
        {
          left: 818,
          tooltip: { placement: 'left', text: 'Уютные торговые аллеи' },
          top: 853,
        },
      ]),
    },
    {
      ...createDescription([
        'Сложная пластика силуэтов и уникальность зданий достигаются за счёт различных архитектурных приёмов: эркеров,',
        'террас, балконов и отделочных материалов с выразительной фактурой. За счёт этого дома выглядят эффектно,',
        'а в квартирах появляются необычные и функциональные планировочные решения.',
      ]),
      imageAlt: 'Фасад дома Серии плюс со сложной пластикой силуэта',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/thoughtful-architecture/2.webp`,
      markers: createSlideMarkers([
        {
          left: 890,
          tooltip: { placement: 'right', text: 'Яркая пластика фасадов' },
          top: 217,
        },
        {
          left: 682,
          tooltip: { placement: 'right', text: 'Террасы' },
          top: 611,
        },
        {
          left: 1149,
          tooltip: { placement: 'right', text: 'Окна в пол' },
          top: 651,
        },
      ]),
    },
    {
      ...createDescription([
        'В каждом проекте стремимся создавать запоминающиеся',
        'архитектурные образы и используем самые современные',
        'фасадные материалы.',
      ]),
      imageAlt: 'Современные фасадные материалы в проекте Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/thoughtful-architecture/3.webp`,
      markers: createSlideMarkers([
        {
          left: 817,
          tooltip: { placement: 'right', text: 'Выразительное завершение корпуса' },
          top: 452,
        },
        {
          left: 612,
          tooltip: { placement: 'right', text: 'Технические лоджии' },
          top: 612,
        },
      ]),
    },
    {
      ...createDescription([
        'Игра света и сочетание текстур на фасадах наших зданий —',
        'результат искусного сочетания металла, алюминиевого композита,',
        'стекла и бетонной плитки необычных форм.',
      ]),
      imageAlt: 'Сочетание текстур на фасаде дома Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/thoughtful-architecture/4.webp`,
      markers: createSlideMarkers([
        {
          left: 505,
          tooltip: { placement: 'left', text: 'Алюмокомпозитные панели' },
          top: 414,
        },
        {
          left: 1151,
          tooltip: { placement: 'right', text: 'Бетонная плитка' },
          top: 446,
        },
        {
          left: 643,
          tooltip: { placement: 'right', text: 'Угловое окно' },
          top: 477,
        },
        {
          left: 222,
          tooltip: { placement: 'right', text: 'Эркер' },
          top: 561,
        },
      ]),
    },
  ],
  title: 'Продуманная архитектура',
});
